/*
PW Confirm Action
Request the user to confirm a specified action before proceeding
*/

import React from 'react'
import T from 'prop-types'
import cx from 'classnames'
import DropdownMenu from './DropdownMenu'
import LongPress from './LongPress'

export default class ConfirmAction extends React.Component {
  static displayName = 'ConfirmAction'

  static propTypes = {
    buttonClassName: T.string,
    buttonMode: T.bool, //true will render a button that draws the confirmation dialog in a tooltip-style menu
    buttonText: T.oneOfType([T.string, T.element]),
    className: T.string,
    confirmText: T.string,
    disabled: T.bool,
    tooltip: T.string,
    menuClassName: T.string,
    message: T.string,
    onCanceled: T.func,
    onConfirmed: T.func.isRequired,
    title: T.string
  }

  static defaultProps = {
    title: 'Please confirm',
    menuClassName: '',
    message: 'Please confirm the requested action.',
    confirmText: 'Yes, proceed',
    className: '',
    disabled: false,
    buttonMode: false,
    buttonText: ''
  }

  _onConfirmClicked = () => {
    this._closeMenuIfPresent()
    const onConfirmed = this.props.onConfirmed
    if (onConfirmed) {
      onConfirmed()
    }
  }

  _onCancelClicked = e => {
    e.stopPropagation()
    this._closeMenuIfPresent()
    const onCanceled = this.props.onCanceled
    if (onCanceled) {
      onCanceled()
    }
  }

  _closeMenuIfPresent = () => {
    if (this._dropdownRef) {
      this._dropdownRef.closeMenu()
    }
  }

  _bindMenuRef = c => {
    this._dropdownRef = c
  }

  _renderDialog = () => {
    const props = this.props
    return (
      <div className={cx('confirm_action active', props.className)}>
        <h6>
          {props.title}
        </h6>
        <p>
          {props.message}
        </p>
        <div className="btn-group">
          <LongPress
            className="btn btn-default btn-mini"
            data-testid={props.confirmBtnTestId}
            onPressed={this._onConfirmClicked}
            pressTime={1000}
          >
            {props.confirmText}
          </LongPress>
          <span
            className="btn btn-primary btn-mini"
            onClick={this._onCancelClicked}
          >
            Cancel
          </span>
        </div>
      </div>
    )
  }

  render() {
    const props = this.props
    return props.buttonMode
      ? <DropdownMenu
          buttonClasses={props.buttonClassName}
          disabled={props.disabled}
          label={props.buttonText}
          menuClasses={`confirm_dropdown ${props.menuClassName}`}
          omitCaret
          ref={this._bindMenuRef}
          tooltip={props.tooltip}
        >
          {this._renderDialog()}
        </DropdownMenu>
      : this._renderDialog()
  }
}
